import { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import {
  ADMIN_ORDER_UPDATE_STATUS,
  ORDER_ADMIN_FIND_ORDER_LOG,
} from "../../../lib/endpoints/order";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import { OrderModel } from "../../../models/order";

interface Props {
  onClose: VoidFunction;
  onRefetchData: () => Promise<void>;
  selectedData: OrderModel;
}

const useOrderDetail = ({ onClose, onRefetchData, selectedData }: Props) => {
  // variables
  const [dataOrderLog, setDataOrderLog] = useState<OrderModel>(null!);
  const [loadingGetOrderLog, setLoadingGetOrderLog] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] =
    useState<boolean>(false);
  // functions
  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleAcceptOrder = async () => {
    try {
      setLoadingConfirmDialog(true);
      await axios.post(
        `${ADMIN_ORDER_UPDATE_STATUS}?orderId=${
          selectedData?.id
        }&status=${convertOrderStatusEnumToStatusCode(
          OrderStatusEnum.Delivered
        )}`
      );
      await onRefetchData();
      onClose();
    } catch (err) {
      window.alert("server error please try again");
    } finally {
      setLoadingConfirmDialog(false);
    }
  };

  const handleGetOrderLog = async () => {
    try {
      setLoadingGetOrderLog(true);
      console.log( ORDER_ADMIN_FIND_ORDER_LOG + "?orderId=" + selectedData?.id)
      const res = await axios.get(
        ORDER_ADMIN_FIND_ORDER_LOG + "?orderId=" + selectedData?.id
      );
      console.log('res=',res)
      console.log('data order log=',res?.data[res?.data?.length - 1])
      if (res?.data?.length) {
        setDataOrderLog(res?.data[res?.data?.length - 1]);
      }
    } catch (err) {
      console.log("error=", err);
    } finally {
      setLoadingGetOrderLog(false);
    }
  };

  useEffect(() => {
    if (selectedData?.updateByAdmin) {
      handleGetOrderLog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData]);

  return {
    openConfirmDialog,
    loadingConfirmDialog,
    handleOpenConfirmDialog,
    handleCloseConfirmDialog,
    handleAcceptOrder,
    loadingGetOrderLog,
    dataOrderLog
  };
};
export default useOrderDetail;
